import { render } from "./ContactCTAButtons.vue?vue&type=template&id=a9c0e9c8&scoped=true"
import script from "./ContactCTAButtons.vue?vue&type=script&lang=ts"
export * from "./ContactCTAButtons.vue?vue&type=script&lang=ts"

import "./ContactCTAButtons.vue?vue&type=style&index=0&id=a9c0e9c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9c0e9c8"

export default script